import React, { useEffect } from 'react'
import { useGetCurrentUserInfoQuery, usePostUserChangePasswordMutation } from '../../store/api/userApi';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

import PasswordForm from '../../../src/components/TextBox/PasswordForm';
import ConfirmPasswordForm from '../../../src/components/TextBox/ConfirmPasswordForm';
const Dashboard = () => {
  const { data: userInfoData } = useGetCurrentUserInfoQuery();
  const { control, handleSubmit, watch, formState: { errors }, reset } = useForm();

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (userInfoData && userInfoData?.data?.changePassword) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [userInfoData])

  const [addChangePassword] = usePostUserChangePasswordMutation();
  async function onSubmit(data) {

    const addData = await addChangePassword({
      userId: userInfoData?.data?.userId,
      ...data
    })

    if (addData?.data?.statusCode === 200) {
      toast.success('Changed Password');
      handleClose();
      reset()
    } else {
      toast.error('Error');
    }

  };

  return (
    <div>
      <Dialog open={open} fullWidth>
        <DialogTitle sx={{ fontSize: 24 }}>
          Change Password
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: 16 }}>
            Want to change your password?
          </DialogContentText>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
              <Grid item xs={6} mt={1}>
                <PasswordForm control={control} errors={errors}
                  dynamicField='password' label='Password' required={true} min={7} max={20} />
              </Grid>
              <Grid item xs={6} mt={1}>
                <ConfirmPasswordForm control={control} errors={errors} dynamicField='confirmPassword'
                  label='Confirm Password' password={watch('password')} />
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' onClick={handleSubmit(onSubmit)}>Set Password</Button>
        </DialogActions>
      </Dialog>

    </div>
  )
}

export default Dashboard